import FraudRuleService from "../../../services/FraudRuleService";

const actions = {
    async GET_RULE_CANDIDATES(context) {
        if (context.rootState.commonStates.selectedEntity) {
            context.commit("changeLoading", true);
            try {
                const req = {
                    selectedEntityId: context.rootState.commonStates.selectedEntity,
                    selectedState: context.state.selectedState
                }
                const { data } = await FraudRuleService.getRuleCandidates(req);
                context.commit("updateRules", data.result)
            } catch (error) {
                console.log('Error', error);
            }
            context.commit("changeLoading", false);
        }
    },
    async GET_RULES(context) {
        if (context.rootState.commonStates.selectedEntity) {
            context.commit("changeLoading", true);
            try {
                const { data } = await FraudRuleService.getRules(context.rootState.commonStates.selectedEntity);
                context.commit("updateRules", data.result)
            } catch (error) {
                console.log('Error', error);
            }
            context.commit("changeLoading", false);
        }
    },
    async DELETE_RULE(context, item) {
        context.commit("changeLoading", true);
        try {
            await FraudRuleService.delete(item.ruleId);
        } catch (error) {
            console.log(error);
        }
        context.commit("changeLoading", false);
        context.dispatch("GET_RULE_CANDIDATES");
    },
    async CREATE_RULE_DELETE_APPROVAL_CANDIDATE(context, item) {
        context.commit("changeLoading", true);
        try {
            await FraudRuleService.createRuleDeleteApprovalCandidate(item.id);
        } catch (error) {
            console.log(error);
        }
        context.commit("changeLoading", false);
        context.dispatch("GET_RULES");
    },
    async DELETE_RULE_CANDIDATE(context, item) {
        context.commit("changeLoading", true);
        try {
            await FraudRuleService.deleteCandidate(item.id);
        } catch (error) {
            console.log(error);
        }
        context.commit("changeLoading", false);
        context.dispatch("GET_RULE_CANDIDATES");
    },
    async ADD_RULE(context, rule) {
        context.commit("changeLoading", true);
        try {
            await FraudRuleService.add(rule);
        } catch (error) {
            console.log(error);
        }

        context.commit("changeLoading", false);
    },
    async UPDATE_RULE(context, rule) {
        context.commit("changeLoading", true);
        try {
            await FraudRuleService.update(rule);
        } catch (error) {
            console.log(error);
        }
        context.commit("changeLoading", false);
    },
    async CHANGE_CANDIDATE_STATE(context, item) {
        context.commit("changeLoading", true);
        try {
            await FraudRuleService.changeCandidateState(item);
        } catch (error) {
            console.log(error);
        }
        context.commit("changeLoading", false);
        context.dispatch("GET_RULE_CANDIDATES");
    },
}

export default actions;